export default __webpack_public_path__ + "static/media/job_offer10_xl.e2517218.jpg";